// @flow
import React from "react";
import Search from "../../../svg/search.svg";

import "./searchIcon.scss";

type Props = {
  className: string
};

const SearchIcon = ({ className }: Props) => (
  <Search className={`c-search-icon ${className}`} />
);

SearchIcon.defaultProps = {
  className: ""
};

export default SearchIcon;
